//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DocumentSigningClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetDocumentSignersAvailableRolesDocumentSigningQueryParameters = {
  revisionId: number ;
}

export type AddDocumentSignersRoleDocumentSigningQueryParameters = {
  documentId: number ;
  roleId: number ;
}

export type RemoveDocumentSignersRoleDocumentSigningQueryParameters = {
  documentId: number ;
  roleId: number ;
}

export type GetDocumentsSigningStatusDocumentSigningQueryParameters = {
  revisionId: number ;
}

export type UpdateRevisionDocumentsSigningStatusDocumentSigningQueryParameters = {
  revisionId: number ;
}

export type StartRevisionSigningDocumentSigningQueryParameters = {
  revisionId: number ;
  documentIds?: number[] | undefined ;
}

export type StopRevisionSigningDocumentSigningQueryParameters = {
  revisionId: number ;
  documentIds?: number[] | undefined ;
}

export type StopDocumentSigningDocumentSigningQueryParameters = {
  documentId: number ;
}

export type GetSignerToResendNotificationsDocumentSigningQueryParameters = {
  revision: number ;
}

export type ResendNotificationToSignerDocumentSigningQueryParameters = {
  documentId: number ;
}

export function getDocumentSignersAvailableRolesUrl(revisionId: number): string {
  let url_ = getBaseUrl() + "/api/document-signing/{revisionId}/available-roles";
if (revisionId === undefined || revisionId === null)
  throw new Error("The parameter 'revisionId' must be defined.");
url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDocumentSignersAvailableRolesDefaultOptions: Omit<UseQueryOptions<Types.AvailableRolesDto[], unknown, Types.AvailableRolesDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AvailableRolesDto[], unknown, Types.AvailableRolesDto[]>, 'queryFn'>> = {
};
export function getGetDocumentSignersAvailableRolesDefaultOptions() {
  return getDocumentSignersAvailableRolesDefaultOptions;
};
export function setGetDocumentSignersAvailableRolesDefaultOptions(options: typeof getDocumentSignersAvailableRolesDefaultOptions) {
  getDocumentSignersAvailableRolesDefaultOptions = options;
}

export function getDocumentSignersAvailableRolesQueryKey(revisionId: number): QueryKey;
export function getDocumentSignersAvailableRolesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { revisionId,  } = params[0] as GetDocumentSignersAvailableRolesDocumentSigningQueryParameters;

    return trimArrayEnd([
        'DocumentSigningClient',
        'getDocumentSignersAvailableRoles',
        revisionId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentSigningClient',
        'getDocumentSignersAvailableRoles',
        ...params
      ]);
  }
}
export function __getDocumentSignersAvailableRoles(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDocumentSignersAvailableRoles(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetDocumentSignersAvailableRolesQuery<TSelectData = Types.AvailableRolesDto[], TError = unknown>(dto: GetDocumentSignersAvailableRolesDocumentSigningQueryParameters, options?: Omit<UseQueryOptions<Types.AvailableRolesDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetDocumentSignersAvailableRolesQuery<TSelectData = Types.AvailableRolesDto[], TError = unknown>(revisionId: number, options?: Omit<UseQueryOptions<Types.AvailableRolesDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDocumentSignersAvailableRolesQuery<TSelectData = Types.AvailableRolesDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AvailableRolesDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let revisionId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ revisionId,  } = params[0] as GetDocumentSignersAvailableRolesDocumentSigningQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [revisionId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AvailableRolesDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDocumentSignersAvailableRoles(context, axiosConfig) : __getDocumentSignersAvailableRoles,
    queryKey: getDocumentSignersAvailableRolesQueryKey(revisionId),
    ...getDocumentSignersAvailableRolesDefaultOptions as unknown as Omit<UseQueryOptions<Types.AvailableRolesDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetDocumentSignersAvailableRolesData(queryClient: QueryClient, updater: (data: Types.AvailableRolesDto[] | undefined) => Types.AvailableRolesDto[], revisionId: number) {
  queryClient.setQueryData(getDocumentSignersAvailableRolesQueryKey(revisionId),
    updater
  );
}

export function setGetDocumentSignersAvailableRolesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AvailableRolesDto[] | undefined) => Types.AvailableRolesDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function addDocumentSignersRoleUrl(documentId: number, roleId: number): string {
  let url_ = getBaseUrl() + "/api/document-signing/{documentId}/roles/{roleId}";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
if (roleId === undefined || roleId === null)
  throw new Error("The parameter 'roleId' must be defined.");
url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addDocumentSignersRoleMutationKey(documentId: number, roleId: number): MutationKey {
  return trimArrayEnd([
      'DocumentSigningClient',
      'addDocumentSignersRole',
      documentId as any,
      roleId as any,
    ]);
}

export function useAddDocumentSignersRoleMutation<TContext>(documentId: number, roleId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = addDocumentSignersRoleMutationKey(documentId, roleId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.addDocumentSignersRole(documentId, roleId),
    mutationKey: key,
  });
}
  
type AddDocumentSignersRole__MutationParameters = AddDocumentSignersRoleDocumentSigningQueryParameters

export function useAddDocumentSignersRoleMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, AddDocumentSignersRole__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: AddDocumentSignersRoleDocumentSigningQueryParameters}): UseMutationResult<void, unknown, AddDocumentSignersRole__MutationParameters, TContext> {
  const key = addDocumentSignersRoleMutationKey(options?.parameters?.documentId!, options?.parameters?.roleId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: AddDocumentSignersRole__MutationParameters) => Client.addDocumentSignersRole(data.documentId ?? options?.parameters?.documentId!, data.roleId ?? options?.parameters?.roleId!),
  mutationKey: key,
});
}
  
export function removeDocumentSignersRoleUrl(documentId: number, roleId: number): string {
  let url_ = getBaseUrl() + "/api/document-signing/{documentId}/roles/{roleId}";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
if (roleId === undefined || roleId === null)
  throw new Error("The parameter 'roleId' must be defined.");
url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeDocumentSignersRoleMutationKey(documentId: number, roleId: number): MutationKey {
  return trimArrayEnd([
      'DocumentSigningClient',
      'removeDocumentSignersRole',
      documentId as any,
      roleId as any,
    ]);
}

export function useRemoveDocumentSignersRoleMutation<TContext>(documentId: number, roleId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeDocumentSignersRoleMutationKey(documentId, roleId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeDocumentSignersRole(documentId, roleId),
    mutationKey: key,
  });
}
  
type RemoveDocumentSignersRole__MutationParameters = RemoveDocumentSignersRoleDocumentSigningQueryParameters

export function useRemoveDocumentSignersRoleMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveDocumentSignersRole__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveDocumentSignersRoleDocumentSigningQueryParameters}): UseMutationResult<void, unknown, RemoveDocumentSignersRole__MutationParameters, TContext> {
  const key = removeDocumentSignersRoleMutationKey(options?.parameters?.documentId!, options?.parameters?.roleId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveDocumentSignersRole__MutationParameters) => Client.removeDocumentSignersRole(data.documentId ?? options?.parameters?.documentId!, data.roleId ?? options?.parameters?.roleId!),
  mutationKey: key,
});
}
  
export function getDocumentsSigningStatusUrl(revisionId: number): string {
  let url_ = getBaseUrl() + "/api/document-signing/{revisionId}/signing-status";
if (revisionId === undefined || revisionId === null)
  throw new Error("The parameter 'revisionId' must be defined.");
url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDocumentsSigningStatusDefaultOptions: Omit<UseQueryOptions<Types.DocumentSigningStatusDto[], unknown, Types.DocumentSigningStatusDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DocumentSigningStatusDto[], unknown, Types.DocumentSigningStatusDto[]>, 'queryFn'>> = {
};
export function getGetDocumentsSigningStatusDefaultOptions() {
  return getDocumentsSigningStatusDefaultOptions;
};
export function setGetDocumentsSigningStatusDefaultOptions(options: typeof getDocumentsSigningStatusDefaultOptions) {
  getDocumentsSigningStatusDefaultOptions = options;
}

export function getDocumentsSigningStatusQueryKey(revisionId: number): QueryKey;
export function getDocumentsSigningStatusQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { revisionId,  } = params[0] as GetDocumentsSigningStatusDocumentSigningQueryParameters;

    return trimArrayEnd([
        'DocumentSigningClient',
        'getDocumentsSigningStatus',
        revisionId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentSigningClient',
        'getDocumentsSigningStatus',
        ...params
      ]);
  }
}
export function __getDocumentsSigningStatus(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDocumentsSigningStatus(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetDocumentsSigningStatusQuery<TSelectData = Types.DocumentSigningStatusDto[], TError = unknown>(dto: GetDocumentsSigningStatusDocumentSigningQueryParameters, options?: Omit<UseQueryOptions<Types.DocumentSigningStatusDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetDocumentsSigningStatusQuery<TSelectData = Types.DocumentSigningStatusDto[], TError = unknown>(revisionId: number, options?: Omit<UseQueryOptions<Types.DocumentSigningStatusDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDocumentsSigningStatusQuery<TSelectData = Types.DocumentSigningStatusDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DocumentSigningStatusDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let revisionId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ revisionId,  } = params[0] as GetDocumentsSigningStatusDocumentSigningQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [revisionId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DocumentSigningStatusDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDocumentsSigningStatus(context, axiosConfig) : __getDocumentsSigningStatus,
    queryKey: getDocumentsSigningStatusQueryKey(revisionId),
    ...getDocumentsSigningStatusDefaultOptions as unknown as Omit<UseQueryOptions<Types.DocumentSigningStatusDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetDocumentsSigningStatusData(queryClient: QueryClient, updater: (data: Types.DocumentSigningStatusDto[] | undefined) => Types.DocumentSigningStatusDto[], revisionId: number) {
  queryClient.setQueryData(getDocumentsSigningStatusQueryKey(revisionId),
    updater
  );
}

export function setGetDocumentsSigningStatusDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DocumentSigningStatusDto[] | undefined) => Types.DocumentSigningStatusDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateRevisionDocumentsSigningStatusUrl(revisionId: number): string {
  let url_ = getBaseUrl() + "/api/document-signing/{revisionId}/update";
if (revisionId === undefined || revisionId === null)
  throw new Error("The parameter 'revisionId' must be defined.");
url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateRevisionDocumentsSigningStatusMutationKey(revisionId: number): MutationKey {
  return trimArrayEnd([
      'DocumentSigningClient',
      'updateRevisionDocumentsSigningStatus',
      revisionId as any,
    ]);
}

export function useUpdateRevisionDocumentsSigningStatusMutation<TContext>(revisionId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = updateRevisionDocumentsSigningStatusMutationKey(revisionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.updateRevisionDocumentsSigningStatus(revisionId),
    mutationKey: key,
  });
}
  
type UpdateRevisionDocumentsSigningStatus__MutationParameters = UpdateRevisionDocumentsSigningStatusDocumentSigningQueryParameters

export function useUpdateRevisionDocumentsSigningStatusMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, UpdateRevisionDocumentsSigningStatus__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateRevisionDocumentsSigningStatusDocumentSigningQueryParameters}): UseMutationResult<void, unknown, UpdateRevisionDocumentsSigningStatus__MutationParameters, TContext> {
  const key = updateRevisionDocumentsSigningStatusMutationKey(options?.parameters?.revisionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdateRevisionDocumentsSigningStatus__MutationParameters) => Client.updateRevisionDocumentsSigningStatus(data.revisionId ?? options?.parameters?.revisionId!),
  mutationKey: key,
});
}
  
export function startRevisionSigningUrl(revisionId: number, documentIds?: number[] | undefined): string {
  let url_ = getBaseUrl() + "/api/document-signing/revision/{revisionId}?";
if (revisionId === undefined || revisionId === null)
  throw new Error("The parameter 'revisionId' must be defined.");
url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
if (documentIds === null)
    throw new Error("The parameter 'documentIds' cannot be null.");
else if (documentIds !== undefined)
    documentIds && documentIds.forEach(item => { url_ += "documentIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function startRevisionSigningMutationKey(revisionId: number, documentIds?: number[] | undefined): MutationKey {
  return trimArrayEnd([
      'DocumentSigningClient',
      'startRevisionSigning',
      revisionId as any,
      documentIds as any,
    ]);
}

export function useStartRevisionSigningMutation<TContext>(revisionId: number, documentIds?: number[] | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = startRevisionSigningMutationKey(revisionId, documentIds);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.startRevisionSigning(revisionId, documentIds),
    mutationKey: key,
  });
}
  
type StartRevisionSigning__MutationParameters = StartRevisionSigningDocumentSigningQueryParameters

export function useStartRevisionSigningMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, StartRevisionSigning__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: StartRevisionSigningDocumentSigningQueryParameters}): UseMutationResult<void, unknown, StartRevisionSigning__MutationParameters, TContext> {
  const key = startRevisionSigningMutationKey(options?.parameters?.revisionId!, options?.parameters?.documentIds!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: StartRevisionSigning__MutationParameters) => Client.startRevisionSigning(data.revisionId ?? options?.parameters?.revisionId!, data.documentIds ?? options?.parameters?.documentIds!),
  mutationKey: key,
});
}
  
export function stopRevisionSigningUrl(revisionId: number, documentIds?: number[] | undefined): string {
  let url_ = getBaseUrl() + "/api/document-signing/revision/{revisionId}?";
if (revisionId === undefined || revisionId === null)
  throw new Error("The parameter 'revisionId' must be defined.");
url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
if (documentIds === null)
    throw new Error("The parameter 'documentIds' cannot be null.");
else if (documentIds !== undefined)
    documentIds && documentIds.forEach(item => { url_ += "documentIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function stopRevisionSigningMutationKey(revisionId: number, documentIds?: number[] | undefined): MutationKey {
  return trimArrayEnd([
      'DocumentSigningClient',
      'stopRevisionSigning',
      revisionId as any,
      documentIds as any,
    ]);
}

export function useStopRevisionSigningMutation<TContext>(revisionId: number, documentIds?: number[] | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = stopRevisionSigningMutationKey(revisionId, documentIds);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.stopRevisionSigning(revisionId, documentIds),
    mutationKey: key,
  });
}
  
type StopRevisionSigning__MutationParameters = StopRevisionSigningDocumentSigningQueryParameters

export function useStopRevisionSigningMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, StopRevisionSigning__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: StopRevisionSigningDocumentSigningQueryParameters}): UseMutationResult<void, unknown, StopRevisionSigning__MutationParameters, TContext> {
  const key = stopRevisionSigningMutationKey(options?.parameters?.revisionId!, options?.parameters?.documentIds!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: StopRevisionSigning__MutationParameters) => Client.stopRevisionSigning(data.revisionId ?? options?.parameters?.revisionId!, data.documentIds ?? options?.parameters?.documentIds!),
  mutationKey: key,
});
}
  
export function stopDocumentSigningUrl(documentId: number): string {
  let url_ = getBaseUrl() + "/api/document-signing/document/{documentId}";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function stopDocumentSigningMutationKey(documentId: number): MutationKey {
  return trimArrayEnd([
      'DocumentSigningClient',
      'stopDocumentSigning',
      documentId as any,
    ]);
}

export function useStopDocumentSigningMutation<TContext>(documentId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = stopDocumentSigningMutationKey(documentId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.stopDocumentSigning(documentId),
    mutationKey: key,
  });
}
  
type StopDocumentSigning__MutationParameters = StopDocumentSigningDocumentSigningQueryParameters

export function useStopDocumentSigningMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, StopDocumentSigning__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: StopDocumentSigningDocumentSigningQueryParameters}): UseMutationResult<void, unknown, StopDocumentSigning__MutationParameters, TContext> {
  const key = stopDocumentSigningMutationKey(options?.parameters?.documentId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: StopDocumentSigning__MutationParameters) => Client.stopDocumentSigning(data.documentId ?? options?.parameters?.documentId!),
  mutationKey: key,
});
}
  
export function getSignerToResendNotificationsUrl(revision: number): string {
  let url_ = getBaseUrl() + "/api/document-signing/revision/{revision}/resend-notification";
if (revision === undefined || revision === null)
  throw new Error("The parameter 'revision' must be defined.");
url_ = url_.replace("{revision}", encodeURIComponent("" + revision));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSignerToResendNotificationsDefaultOptions: Omit<UseQueryOptions<Types.SignerToResendNotificationDto[], unknown, Types.SignerToResendNotificationDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SignerToResendNotificationDto[], unknown, Types.SignerToResendNotificationDto[]>, 'queryFn'>> = {
};
export function getGetSignerToResendNotificationsDefaultOptions() {
  return getSignerToResendNotificationsDefaultOptions;
};
export function setGetSignerToResendNotificationsDefaultOptions(options: typeof getSignerToResendNotificationsDefaultOptions) {
  getSignerToResendNotificationsDefaultOptions = options;
}

export function getSignerToResendNotificationsQueryKey(revision: number): QueryKey;
export function getSignerToResendNotificationsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { revision,  } = params[0] as GetSignerToResendNotificationsDocumentSigningQueryParameters;

    return trimArrayEnd([
        'DocumentSigningClient',
        'getSignerToResendNotifications',
        revision as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentSigningClient',
        'getSignerToResendNotifications',
        ...params
      ]);
  }
}
export function __getSignerToResendNotifications(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSignerToResendNotifications(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSignerToResendNotificationsQuery<TSelectData = Types.SignerToResendNotificationDto[], TError = unknown>(dto: GetSignerToResendNotificationsDocumentSigningQueryParameters, options?: Omit<UseQueryOptions<Types.SignerToResendNotificationDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetSignerToResendNotificationsQuery<TSelectData = Types.SignerToResendNotificationDto[], TError = unknown>(revision: number, options?: Omit<UseQueryOptions<Types.SignerToResendNotificationDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSignerToResendNotificationsQuery<TSelectData = Types.SignerToResendNotificationDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SignerToResendNotificationDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let revision: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ revision,  } = params[0] as GetSignerToResendNotificationsDocumentSigningQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [revision, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SignerToResendNotificationDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSignerToResendNotifications(context, axiosConfig) : __getSignerToResendNotifications,
    queryKey: getSignerToResendNotificationsQueryKey(revision),
    ...getSignerToResendNotificationsDefaultOptions as unknown as Omit<UseQueryOptions<Types.SignerToResendNotificationDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetSignerToResendNotificationsData(queryClient: QueryClient, updater: (data: Types.SignerToResendNotificationDto[] | undefined) => Types.SignerToResendNotificationDto[], revision: number) {
  queryClient.setQueryData(getSignerToResendNotificationsQueryKey(revision),
    updater
  );
}

export function setGetSignerToResendNotificationsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SignerToResendNotificationDto[] | undefined) => Types.SignerToResendNotificationDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function resendNotificationToSignerUrl(documentId: number): string {
  let url_ = getBaseUrl() + "/api/document-signing/document/{documentId}/resend-notification";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resendNotificationToSignerMutationKey(documentId: number): MutationKey {
  return trimArrayEnd([
      'DocumentSigningClient',
      'resendNotificationToSigner',
      documentId as any,
    ]);
}

export function useResendNotificationToSignerMutation<TContext>(documentId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = resendNotificationToSignerMutationKey(documentId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.resendNotificationToSigner(documentId),
    mutationKey: key,
  });
}
  
type ResendNotificationToSigner__MutationParameters = ResendNotificationToSignerDocumentSigningQueryParameters

export function useResendNotificationToSignerMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ResendNotificationToSigner__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ResendNotificationToSignerDocumentSigningQueryParameters}): UseMutationResult<void, unknown, ResendNotificationToSigner__MutationParameters, TContext> {
  const key = resendNotificationToSignerMutationKey(options?.parameters?.documentId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ResendNotificationToSigner__MutationParameters) => Client.resendNotificationToSigner(data.documentId ?? options?.parameters?.documentId!),
  mutationKey: key,
});
}